"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _utils = require("composer-lib/lib/utils");

var _FormattedHTMLMessage = _interopRequireDefault(require("I18n/components/FormattedHTMLMessage"));

var _colors = require("HubStyleTokens/colors");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _react = _interopRequireDefault(require("react"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _UIIcon = _interopRequireDefault(require("UIComponents/icon/UIIcon"));

var _default = (0, _createReactClass.default)({
  displayName: "LockedModal",
  propTypes: {
    iconName: _propTypes.default.string,
    langKey: _propTypes.default.string.isRequired,
    onPrimaryAction: _propTypes.default.func.isRequired,
    onSecondaryAction: _propTypes.default.func,
    subHeadingOptions: _propTypes.default.object
  },
  primaryActionClick: function primaryActionClick(evt) {
    (0, _utils.callIfPossible)(this.props.onPrimaryAction(evt));
  },
  secondaryActionClick: function secondaryActionClick(evt) {
    (0, _utils.callIfPossible)(this.props.onSecondaryAction(evt));
  },
  renderSecondaryButton: function renderSecondaryButton() {
    var _this$props = this.props,
        langKey = _this$props.langKey,
        onSecondaryAction = _this$props.onSecondaryAction;

    if (!onSecondaryAction) {
      return null;
    }

    return _react.default.createElement("p", null, _react.default.createElement("span", {
      className: "locked-modal-secondary-text",
      onClick: this.secondaryActionClick
    }, _react.default.createElement(_FormattedHTMLMessage.default, {
      message: "composer-lib.lockedModal." + langKey + ".secondaryActionText"
    })));
  },
  render: function render() {
    var _this$props2 = this.props,
        iconName = _this$props2.iconName,
        langKey = _this$props2.langKey,
        subHeadingOptions = _this$props2.subHeadingOptions;
    return _react.default.createElement("div", {
      className: "locked-editor-modal"
    }, _react.default.createElement("div", {
      className: "locked-editor-modal locked-editor-background"
    }), _react.default.createElement("div", {
      className: "locked-editor-modal locked-editor-content"
    }, _react.default.createElement(_UIIcon.default, {
      color: _colors.OLAF,
      name: iconName,
      size: "lg"
    }), _react.default.createElement("h1", null, _react.default.createElement(_FormattedHTMLMessage.default, {
      message: "composer-lib.lockedModal." + langKey + ".heading"
    })), _react.default.createElement("p", null, _react.default.createElement(_FormattedHTMLMessage.default, {
      message: "composer-lib.lockedModal." + langKey + ".subHeading",
      options: subHeadingOptions
    })), _react.default.createElement(_UIButton.default, {
      onClick: this.primaryActionClick,
      role: "button",
      use: "primary"
    }, _react.default.createElement(_FormattedHTMLMessage.default, {
      message: "composer-lib.lockedModal." + langKey + ".primaryActionText"
    })), this.renderSecondaryButton()));
  }
});

exports.default = _default;
module.exports = exports.default;